import { useQuery } from '@tanstack/react-query';

import { IWebhookConfig } from '../types';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

type ImperativeRequestFn = ReturnType<typeof useImperativeRequestWrapper>[1];

const getWebhookConfigs = async ({
  partnerId,
  makeRequest,
}: {
  partnerId: string;
  makeRequest: ImperativeRequestFn;
}): Promise<IWebhookConfig[]> => {
  const { data, error } = await makeRequest({
    path: `/partners/${partnerId}/webhooks/configs`,
    method: 'get',
  });
  if (error) throw new Error(error?.message ?? String(error));

  return data?.configs ?? [];
};

type QueryFnType = typeof getWebhookConfigs;

export const useGetWebhookConfigs = (
  partnerId: string,
  config?: QueryConfig<QueryFnType>
) => {
  const [, makeRequest] = useImperativeRequestWrapper('lpVillageV3');

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    enabled: !!partnerId,
    staleTime: 5 * 60 * 1000,
    ...config,
    queryKey: ['webhook-configs', partnerId],
    queryFn: () => getWebhookConfigs({ partnerId, makeRequest }),
  });
};
